import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { startCase } from 'lodash';
import { processValidate } from 'infrastructure/form';
import renderChromeColorPickerField from './ChromeColorPicker';

const ColorPicker = props => {
  const {
    name,
    label,
    validate,
    onChange,
    hasAttemptedSubmit,
    publishRequiredOnly,
    ...fieldProps
  } = props;
  return (
    <>
      <Field
        {...fieldProps}
        name={name}
        validate={processValidate(label || startCase(name), validate, {
          ...fieldProps,
          publishRequiredOnly,
        })}
        render={({ field, form, ...p }) =>
          renderChromeColorPickerField({
            input: {
              ...field,
              onChange: value => {
                form.setFieldValue(name, value.hex);
                onChange(value.hex);
              },
            },
            label,
            field,
            form,
            ...p,
            hasAttemptedSubmit,
            meta: {},
          })
        }
      />
    </>
  );
};

ColorPicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  validate: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  publishRequiredOnly: PropTypes.bool,
};
ColorPicker.defaultProps = {
  label: '',
  name: '',
  validate: [],
  onChange: () => {},
  publishRequiredOnly: false,
};

export default ColorPicker;
